import ready from "../parent/js/lib/ready";
import promiseIdle from "../parent/js/lib/promise-idle";
import initScrollingDown from '../parent/js/lib/scrolling-down';
import initTableOverflow from '../parent/js/table-overflow';
import initNav from './nav';
import initHistory from './history';
import '../parent/js/search';
import '../parent/js/faq';
import '../parent/js/submenu';
import '../parent/js/force-image-loading-on-print';
import '../parent/js/content-link-handler';
import './menu-lang';
import '../parent/js/load';

import '../parent/js/tac/vimeo';
import '../parent/js/tac/youtube';
// import './tac/googletagmanager';
// import './tac/gtm-consent';
// import './tac/gtm';
import '../parent/js/tac';

ready().then(promiseIdle()).then(function init() {
    initScrollingDown();
    initTableOverflow('.overflow-shadows');
    initNav();
    initHistory();

    const anim = document.querySelector('.anniversary-anim');
    if (anim) {
        const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        const url = new URL(anim.src);
        const item = document.createElement('li');
        item.classList.add('skips__item');
        item.hidden = mq.matches;
        const button = document.createElement('button');
        // noinspection JSUnresolvedReference
        button.innerText = window.anniversary_anim.play_label;
        button.setAttribute('aria-pressed', 'true');
        button.classList.add('skips__link');
        button.classList.add('anniv-anim-play');
        item.appendChild(button);
        document.querySelector('.skips__list').appendChild(item);

        function update() {
            const enabled = button.getAttribute('aria-pressed') === 'true' && !mq.matches;
            url.hash = enabled ? '' : 'noanim';
            anim.src = url;
        }

        update();
        
        button.addEventListener('click', () => {
            button.setAttribute('aria-pressed', button.getAttribute('aria-pressed') !== 'true' ? 'true' : 'false');
            update();
        });

        mq.addEventListener('change', e => {
            item.hidden = e.matches;
            update();
        });
    }
});